import {
  APP_CHECK_VIEW_PORT,
  LOAD_FORM_STATE,
  FORM_STATE_LOADED,
  SAVE_APPSTATE_REQUEST,
  SAVE_APPSTATE_SUCCESS,
  SAVE_APPSTATE_FAILURE,
  APP_LOAD_FAILED
} from "../actions/types";

const initialState = {
  mobile: false,
  isAppSaved: false,
  isAppSaving: false,
  isAppFailed: false,
  error: '',
  storedForm: {
    isPending: true
  }
};

export const appReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case APP_CHECK_VIEW_PORT:
      return Object.assign({}, state, {
        mobile: action.payload
      });
    case SAVE_APPSTATE_REQUEST:
      return Object.assign({}, state, {
        error: {},
        isAppSaved: false,
        isAppSaving: true
      });  
    case SAVE_APPSTATE_SUCCESS:
      return Object.assign({}, state, {
        error: {},
        isAppSaved: true,
        isAppSaving: false,
        savedApp: action.payload
      });    
    case SAVE_APPSTATE_FAILURE:
      return Object.assign({}, state, {
        response: {},
        error: action.payload,
        isAppSaved: false,
        isAppSaving: false
      });              
    case LOAD_FORM_STATE:
      return Object.assign({}, state, {
        storedForm: {
          isPending: true,
          ...action.payload
        }
      }); 
    case FORM_STATE_LOADED:
      return Object.assign({}, state, {
        storedForm: {
          ...state.storedForm,
          isPending: false      
        }
      });
    case APP_LOAD_FAILED: 
      return Object.assign({}, state, {
        isAppFailed: true,
        error: action.payload  
      })            
    default:
      return state;
  }
};